import './ReportFormSectionHvacEmpty.scss';
import { HvacGroup } from '@belimo-retrofit-portal/logic';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import { Button } from 'src/modules/common/components/Button';
import { ArrowRightIcon } from 'src/modules/common/icons/ArrowRightIcon';
import { Project } from 'src/modules/common/types/Project';

type Props = {
  readonly group: HvacGroup;
  readonly project: Project;
};

export const ReportFormSectionHvacEmpty = ({ group, project }: Props): React.ReactElement => (
  <div className="bp-report-form-section-hvac-empty">
    <div className="bp-report-form-section-hvac-empty__title">
      <FormattedMessage
        id="report/form/hvac/noData/title"
        values={{ group: GROUP_TITLES[group] }}
      />
    </div>

    <p className="bp-report-form-section-hvac-empty__description">
      <FormattedMessage
        id="report/form/hvac/noData/description"
        values={{ group: GROUP_TITLES[group] }}
      />
    </p>

    <div className="bp-report-form-section-hvac-empty__action">
      <Button
        as={Link}
        to={`/project/${encodeURIComponent(project.id)}/hvac/settings`}
        size="md"
        icon={(
          <div className="bp-report-form-section-hvac-empty__action-icon">
            <ArrowRightIcon/>
          </div>
        )}
      >
        <FormattedMessage id="report/form/hvac/noData/editLink"/>
      </Button>
    </div>
  </div>
);

const GROUP_TITLES = {
  [HvacGroup.EMISSION]: <FormattedMessage id="report/document/hvac/group/emission"/>,
  [HvacGroup.DISTRIBUTION]: <FormattedMessage id="report/document/hvac/group/distribution"/>,
  [HvacGroup.AIR_HANDLER]: <FormattedMessage id="report/document/hvac/group/air_handler"/>,
  [HvacGroup.GENERATION]: <FormattedMessage id="report/document/hvac/group/generation"/>,
};
